var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeya(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1567 1568",
    width: 1567,
    height: 1568,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo (1)-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\t.s0 { fill: #151515 } \n\t\t.s1 { fill: #dde048 } \n\t\t.s2 { fill: #ffffff } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    fillRule: "evenodd",
    className: "s0",
    d: "m0 326c0-180 146-326 326-326h914.8c180 0 326 146 326 326v916c0 180-146 326-326 326h-914.8c-180 0-326-146-326-326zm589.5 480c26.3-94.5 73.2-181.2 135.7-254.4-105.9-96-246.5-155-400.6-155v271.5c109.4 0 206 54.8 264.9 137.9zm652-410.1c-184.7 0-349.4 83.9-458.8 216.1-84.5 103.1-135.7 235.3-135.7 378.8v179.9h272.1v-179.9c0-177.7 144.1-322.7 322.4-322.7z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s1",
    d: "m1241.5 668.1c-178.3 0-322.4 145-322.4 322.7v179.9h-272.1v-179.9c0-143.5 51.2-275.7 135.7-378.8 109.4-132.2 274.1-216.1 458.8-216.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "s2",
    d: "m324.6 668.1v-271.5c154.1 0 294.7 59 400.6 154.9-62.5 73.3-109.4 160-135.7 254.5-58.9-83.2-155.5-137.9-264.9-137.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeya);
export default __webpack_public_path__ + "static/media/teya.ad99f8f58787254602006028063c7a54.svg";
export { ForwardRef as ReactComponent };